import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { PROJECTS_EXPERIMENTS_QUERY_KEY } from '@/entities/experiment/model/useProjectsExperiments';
import { projectApi } from '@/entities/project/api/projectApi';
import type { CreateProjectRequest, ProjectResponse } from '@/entities/project/domain/types';

export const useCreateProject = () => {
  const queryClient = useQueryClient();

  return useMutation<ProjectResponse, Error, CreateProjectRequest>({
    mutationFn: (data: CreateProjectRequest) => projectApi.create(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [PROJECTS_EXPERIMENTS_QUERY_KEY] });
      message.success('프로젝트가 생성되었습니다');
    },
  });
};
